module.exports = __webpack_public_path__ + "media/video-login.4fd9801b.mp4";